import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Col, Container, Row } from "reactstrap"

import ServiceStructure from "../../../components/Services/structure/ServiceStructure"

const ExportInfo = () => {
  const [menu, setMenu] = useState(false)
  const toggle = () => {
    setMenu(!menu)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>License | Export</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">Export License</h6>

                <ServiceStructure
                  detailsType="export"
                  url="licensing-export-apply"
                  serviceType="Export License"
                  department="Environmental Compliance  &amp; Enforcement Division"
                  ENVIRONMENTAL
                  COMPLIANCE
                  AND
                  ENFORCEMENT
                  DIVISION
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ExportInfo
